import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import dp from "../images/logo.png";
import axios from "axios";
import "./Login.css";
import Footer from "./footer";
import { toast, Toaster } from "react-hot-toast";
import { useLocation } from "react-router-dom";
import { useAppContext } from "../contextApi/AppContext";
import { getFCMToken } from "../services/notificationService";

function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const role = location.state?.role || "Student"; // Default to Student if no role is passed
  const [passwordVisible, setPasswordVisible] = useState(false);
  const { login , API_BASE_URL} = useAppContext();
  const [institutionType, setInstitutionType] = useState("Academy"); // Academy by default

  const togglePassword = () => {
    setPasswordVisible(!passwordVisible);
  };
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rollNumber, setRollNumber] = useState("");
  const [Loading, setLoading] = useState(false);

  // Fire-and-forget: registering the FCM token is not needed to show the
  // dashboard, so it should never block login/navigation.
  const fetchFCMToken = async (userId) => {
    try {
      const token = await getFCMToken();
      if (token) {
        await axios.post(`${API_BASE_URL}/notifications/fcm-token`, {
          userId: userId,
          token,
        });
      }
    } catch (err) {
      console.error("FCM token registration failed:", err);
    }
  };

  const handleLogin = async () => {
    setLoading(true);
    if (role === "Admin" || role === "Teacher") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailRegex.test(email)) {
        toast.error("Invalid email format");
        setLoading(false);
        return;
      }
    }
    if(institutionType !== "School" && institutionType !== "Academy") {
      toast.error("Invalid institution type");
      setLoading(false);
      return;
    }

    if (role === "Admin" || role === "Teacher") {
      if (!email || !password) {
        toast.error("Please fill all the fields");
        setLoading(false);
        return;
      }
      console.log("Logging in as:", role, "with email:", email);
      try {
        const res = await axios.post(
          `${API_BASE_URL}/${role.toLowerCase()}/login`,
          {
            email,
            password,
              institution: institutionType, // Send the selected institution type
          },
        );
        if (res?.data.success) {
          console.log("Login response:", res.data);
          // Don't await: neither of these need to finish before we navigate.
          fetchFCMToken(res.data.user.id);
          await login(res?.data.token, res?.data.user);
          toast.success(`${role} Login successful`);

          navigate(`/${role.toLowerCase()}Panel`);
        } else {
          toast.error(res?.data.message || "Login failed");
        }
      } catch (error) {
        toast.error(error.response?.data.message || "Login failed");
      } finally {
        setLoading(false);
      }
    } else {
      if (!rollNumber || !password) {
        toast.error("Please fill all the fields");
        setLoading(false);
        return;
      }
      try {
        const res = await axios.post(
          `${API_BASE_URL}/students/login`,
          {
             institutionPrefix: institutionType === "School" ? "ECS" : "ECA",
            rollNumber,
            password,
          },
        );
        if (res?.data.success) {
          toast.success(`Student Login successful`);
          // Don't await: neither of these need to finish before we navigate.
          fetchFCMToken(res.data.user.id);
          await login(res?.data.token, res?.data.user);

          navigate(`/student/dashboard`);
        } else {
          toast.error(res?.data.message || "Login failed");
        }
      } catch (error) {
        toast.error(error.response?.data.message || "Login failed");
      } finally {
        setLoading(false);
      }
    }
  };


  return (
    <div className="login-page">
      <Toaster />
      <div className="container">
        <div className="d-flex justify-content-center align-items-center">
          <div className="card login-card p-4 p-md-5 text-dark border-0">
            <div className="d-flex justify-content-center mb-2">
              <img
                src={dp}
                alt="EC Portal Logo"
                width="130"
                height="130"
                className="d-inline-block align-text-top"
              />
            </div>

            <div className="text-center mb-4">
              <h1 className="login-title mt-1 mb-2">
                <i
                  style={{ marginRight: "10px" }}
                  className={` fa-solid ${role === "Admin" ? "fa-user-shield" : role === "Teacher" ? "fa-chalkboard-teacher" : "fa-user-graduate"}`}
                ></i>
                Login
              </h1>
              <p className="login-subtitle mb-2">
                Sign in to continue to your dashboard.
              </p>
              <p className="login-note mb-0">
                Use your Identity/roll number and password provided by the
                administration.
              </p>
            </div>

        {/* Institution type toggle (all roles) */}
<div
  className="institution-toggle mb-3"
  role="group"
  aria-label="Institution Type"
>
  <button
    type="button"
    className={`institution-toggle-btn ${institutionType === "School" ? "active" : ""}`}
    onClick={() => setInstitutionType("School")}
  >
    <i className="fa-solid fa-school me-2"></i>
    School
  </button>
  <button
    type="button"
    className={`institution-toggle-btn ${institutionType === "Academy" ? "active" : ""}`}
    onClick={() => setInstitutionType("Academy")}
  >
    <i className="fa-solid fa-graduation-cap me-2"></i>
    Academy
  </button>
</div>

{role !== "Student" ? (
  <div className="input-group flex-nowrap mb-3">
    <span className="input-group-text" id="addon-Email">
      <i className="fa-solid fa-envelope"></i>
    </span>
    <input
      type="email"
      className="form-control"
      placeholder="Eg : abc@gmail.com"
      aria-label="email"
      aria-describedby="addon-Email"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
    />
  </div>
) : (
  <div className="input-group flex-nowrap mb-3">
    <span className="input-group-text" id="addon-Roll Number">
      <i className="fa-solid fa-user-graduate"></i>
    </span>
    <input
      type="number"
      className="form-control"
      placeholder="Eg : 10001"
      aria-label="rollNumber"
      aria-describedby="addon-Roll Number"
      value={rollNumber}
      onChange={(e) => setRollNumber(e.target.value)}
    />
  </div>
)}
            {/* Password Field */}

            <div className="input-group flex-nowrap mb-1">
              <span className="input-group-text" id="addon-password">
                <i className="fa-solid fa-lock"></i>
              </span>
              <input
                type={passwordVisible ? "text" : "password"}
                className="form-control"
                placeholder="Password"
                aria-label="Password"
                aria-describedby="addon-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                className="btn btn-dark"
                type="button"
                onClick={togglePassword}
                tabIndex={-1}
              >
                <i
                  className={`fas ${passwordVisible ? "fa-eye-slash" : "fa-eye"}`}
                ></i>
              </button>
            </div>
            <span
              className="login-forgot d-flex justify-content-end mb-3"
              onClick={() => navigate("/password-reset", { state: { role } })}
            >
              Forgot password?
            </span>

            <div className="d-grid">
              {Loading ? (
                <button
                  className="btn btn-dark login-btn login-loading-btn"
                  type="button"
                  disabled
                >
                  <i className="fas fa-spinner fa-spin me-2"></i>
                  <span className="login-loading-text">Verifying you...</span>
                </button>
              ) : (
                <button
                  className="btn btn-dark login-btn"
                  type="button"
                  onClick={handleLogin}
                >
                  <i className="fas fa-sign-in-alt me-2"></i>
                  Login
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <div style={{ marginTop: "-25px" }}>
        <Footer />
      </div>
    </div>
  );
}

export default Login;